<ng-container *transloco="let t; read: 'inventory.detail.services'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    <div class="xs12col">
      <div class="fieldsetWrapper">
        <fieldset class="fieldsetContainer flexRow">
          <div class="titleAdd">
            <h2 class="xs12col padding-right-small">{{ t('title') }}</h2>
            <button
              kendoButton
              class="addIcon small"
              type="button"
              (click)="openServiceDialog()"
              loadingIndication="/inventoryDevices/createInventoryDeviceService"
              [hidden]="!('Permissions.InventoryDeviceServices.Create' | permission)">
              <span class="icon">
                <img src="../../../assets/icons/add-icon.svg">
              </span>
            </button>
          </div>
          @if (device?.serviceInformation) {
            <div class="xs12col serviceInformation flexColumn">
              <span class="fontBold">{{ t('serviceInformation') }}</span>
              <p>{{ device.serviceInformation }}</p>
            </div>
          }
          @if (services.length == 0) {
            <div class="xs12col">
              <span>{{ t('noServices') }}</span>
            </div>
          }
          @for (service of services; track service.id) {
            <div class="xs12col serviceWrapper">
              <div class="serviceContainer">
                <div class="content">
                  <p>{{ service.remark || '-' }}</p>
                </div>
                <div class="footer xs12col">
                  <div class="firstCol">
                    <div class="dateContainer">
                      <span class="small"><img src="../../../assets/icons/check-icon.svg"> {{ formatDate(service.executionDate) }}</span>
                    </div>
                  </div>
                  <div class="flexRow align-center serviceActionCol">
                    <a
                      class="buttonSecondary actionIcon"
                      [hidden]="!('Permissions.InventoryDeviceServices.Update' | permission)"
                      [attr.tooltip]="t('edit')"
                      flow="up"
                      (click)="openServiceDialog(service)">
                      <img src="../../../assets/icons/edit-icon.svg">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          }
        </fieldset>
      </div>
    </div>
    <!-- Dialog create / edit service -->
    @if (serviceDialogOpened) {
      <kendo-dialog
        title="{{ editingService ? t('update') : t('create') }}"
        (close)="closeServiceDialog()"
        [minWidth]="250"
        [width]="450">
        <form [formGroup]="serviceForm" class="flexColumn">
          @if (device?.serviceInformation) {
            <div class="serviceInformation dialog">
              <span class="fontBold">{{ t('serviceInformation') }}</span>
              <p>{{ device.serviceInformation }}</p>
            </div>
          }
          <kendo-formfield>
            <kendo-label text="{{ t('executionDate') }}*">
              <kendo-datepicker
                formControlName="executionDate"
                placeholder="{{ t('date.placeholder') }}"
                required>
              </kendo-datepicker>
            </kendo-label>
          </kendo-formfield>
          <kendo-formfield>
            <kendo-label [for]="remark" [text]="t('remark')"></kendo-label>
            <kendo-textarea
              kendoTextBox
              type="text"
              [rows]="4"
              class="mbs"
              formControlName="remark"
              #remark>
            </kendo-textarea>
          </kendo-formfield>
          <kendo-dialog-actions>
            <button
              [disabled]="serviceForm.invalid || !serviceForm.dirty"
              type="submit"
              kendoButton
              (click)="submitService()"
              class="buttonPrimary">
              {{ editingService ? tGlobal('save') : t('submit') }}
            </button>
            <button
              kendoButton
              type="button"
              (click)="closeServiceDialog()"
              class="buttonSecondary">
              {{ tGlobal('cancel') }}
            </button>
            <button
              kendoButton
              type="button"
              class="buttonSecondary"
              (click)="deletionDialogOpen()"
              [hidden]="!editingService">
              <img src="../../../assets/icons/delete-icon.svg">
            </button>
          </kendo-dialog-actions>
        </form>
      </kendo-dialog>
    }
    <!-- deletion dialog -->
    @if (deletionDialogOpened) {
      <kendo-dialog
        title="{{ t('confirmDeletion') }}"
        (close)="deletionDialogClose('cancel')"
        [minWidth]="250"
        [width]="450">
        <p style="margin: 30px; text-align: center;">
          {{ t('deletionMessage') }}
        </p>
        <kendo-dialog-actions>
          <button kendoButton (click)="deletionDialogClose('cancel')">{{ tGlobal('cancel') }}</button>
          <button kendoButton (click)="deletionDialogClose('delete')" themeColor="primary">{{ tGlobal('delete') }}
          </button>
        </kendo-dialog-actions>
      </kendo-dialog>
    }
  </ng-container>
</ng-container>